import React, { Component } from 'react';
import classNames from 'classnames';
import ReactResizeDetector from 'react-resize-detector';
import { Button } from '@fiverr-private/fit';
import tracker from '../../../../service/tracker';
import { EVENTS_MAPPING } from '../../../../utils/constants';
import './index.scss';
import { getSubCategoryFilterUrl } from '../../../../utils/url';
import history from '../../../../api/history';

let scrollInterval;

const scroll = (ref, delta) => {
    clearInterval(scrollInterval);
    scrollInterval = setInterval(frame, 2.5);
    const direction = delta / Math.abs(delta);
    let progress = 0;

    function frame() {
        if (progress >= Math.abs(delta)) {
            clearInterval(scrollInterval);
        } else {
            requestAnimationFrame(() => {
                ref.scrollLeft += direction * 2;
            });

            progress++;
        }
    }
};

class NestedSubcategoryNav extends Component {

    constructor(props) {
        super(props);

        this.nav;

        this.state = {
            canScrollLeft: false,
            canScrollRight: false
        };

        this.scrollLeft = this.scrollLeft.bind(this);
        this.scrollRight = this.scrollRight.bind(this);

        this.shouldUpdateCanScrollLeft = this.shouldUpdateCanScrollLeft.bind(this);
        this.shouldUpdateCanScrollRight = this.shouldUpdateCanScrollRight.bind(this);

        this.handleScroll = this.handleScroll.bind(this);
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.buildUrl = this.buildUrl.bind(this);
    }

    componentDidMount() {
        if (!this.nav) {
            return;
        }

        this.nav.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleScroll);

        this.handleScroll();
    }

    componentWillUnmount() {
        this.nav && this.nav.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
    }

    shouldUpdateCanScrollLeft() {
        const scrollLeft = this.nav.scrollLeft,
            canScrollLeft = scrollLeft > 0;

        return this.state.canScrollLeft !== canScrollLeft;
    }

    shouldUpdateCanScrollRight() {
        const scrollLeft = this.nav.scrollLeft,
            scrollView = this.nav.scrollWidth - this.nav.clientWidth,
            canScrollRight = scrollLeft < scrollView;

        return this.state.canScrollRight !== canScrollRight;
    }

    handleScroll() {
        const scrollLeft = this.nav.scrollLeft,
            scrollView = this.nav.scrollWidth - this.nav.clientWidth,
            canScrollLeft = scrollLeft > 0,
            canScrollRight = scrollLeft < scrollView;

        if (this.shouldUpdateCanScrollLeft() || this.shouldUpdateCanScrollRight()) {
            this.setState({
                canScrollLeft,
                canScrollRight
            });
        }
    }

    scrollLeft() {
        scroll(this.nav, -100);
    }

    scrollRight() {
        scroll(this.nav, 100);
    }

    handleLinkClick(e, { url, params }) {
        e.preventDefault && e.preventDefault();
        tracker.click(EVENTS_MAPPING.CLICK.TARGETS.NESTED_SUB_CATEGORY_NAV);

        window.location.href = this.buildUrl({ url, params });
    }

    buildUrl({ url, params }) {
        const { activeFiltersQueryString } = this.props;

        return getSubCategoryFilterUrl(history, url, {
            ...params,
            ref: activeFiltersQueryString
        });
    }

    render() {
        const { children } = this.props.subCategory;
        const nestedSubCategoryItems = children[0].children;
        const { canScrollLeft, canScrollRight } = this.state;

        if (nestedSubCategoryItems.length <= 0) {
            return null;
        }

        return (
            <ReactResizeDetector handleWidth
                refreshMode="throttle"
                refreshRate={400}
                render={({ width }) => (
                    <div className={classNames('nested-subcategory-nav', { 'scroll-left': canScrollLeft, 'scroll-right': canScrollRight })} >
                        <div className={classNames('button-wrap left', { 'visible': canScrollLeft })}>
                            <button onClick={this.scrollLeft}/>
                        </div>
                        <div className={classNames('button-wrap right', { 'visible': canScrollRight })}>
                            <button onClick={this.scrollRight}/>
                        </div>
                        <nav style={{ width }} ref={(_ref) => this.nav = _ref}>
                            {
                                nestedSubCategoryItems.map(({ url, alias, params }) => (
                                    <Button key={alias} href={this.buildUrl({ url, params })} onClick={(e) => this.handleLinkClick(e, { url, params })} color="blue" fill="ghost">
                                        {alias}
                                    </Button>
                                ))
                            }
                        </nav>
                    </div>
                )
                }/>
        );
    }
}

export default NestedSubcategoryNav;
